export const FAVICON_LINKS = [
    {
        rel: "icon",
        href: "/favicon-light.ico",
    },
    {
        rel: "icon",
        href: "/favicon-light.ico",
        media: "(prefers-color-scheme: light)",
    },
    {
        rel: "icon",
        href: "/favicon-dark.ico",
        media: "(prefers-color-scheme: dark)",
    },
    {
        rel: "icon",
        type: "image/png",
        sizes: "64x64",
        href: "/favicon-light-64.png",
        media: "(prefers-color-scheme: light)",
    },
    {
        rel: "icon",
        type: "image/png",
        sizes: "64x64",
        href: "/favicon-dark-64.png",
        media: "(prefers-color-scheme: dark)",
    },
] as const;

const UNREAD_FAVICON_BY_HREF: Readonly<Record<string, string>> = {
    "/favicon-light.ico": "/favicon-light-unread-64.png",
    "/favicon-light-64.png": "/favicon-light-unread-64.png",
    "/favicon-dark.ico": "/favicon-dark-unread-64.png",
    "/favicon-dark-64.png": "/favicon-dark-unread-64.png",
};

export function unreadFaviconHref(href: string): string | null {
    return UNREAD_FAVICON_BY_HREF[href] ?? null;
}
